import config from "../config"
const baseUrl = config.base_url + "container_farm_work_arrange_trigger/"
export default {
    getOperators: {
        url: baseUrl + "getOperators",
        type: "get",
    },
}

